import { Component } from '@angular/core';

@Component({
    selector: 'app-average-value',
    standalone: true,
    imports: [],
    templateUrl: './average-value.component.html',
    styleUrl: './average-value.component.scss'
})
export class AverageValueComponent {}